import { useParams } from 'react-router-dom';

import { Page as CreatePage } from '../create/page';
import { useAddressBookDetailsQuery } from '../queries';

export function Page() {
  const { addressBookID } = useParams();
  const { data } = useAddressBookDetailsQuery({ id: addressBookID });

  return <CreatePage defaultValues={data.contact} />;
}
